import * as React from "react";

import { UpsellProductTile } from "./upsell-product-tile";
import { useEffect, useState } from "react";

export interface UpsellProduct {
  id: string
  price_lowest_au: number
  price_status_au: {}
  rrp_au: number
  base_colour_hex: {}
  label: {}
  colour_base_family: {}
  colour_base: {}
  filter_colour: {}
  description_long: string
  extended_description: string
  heading: {}
  itemcolour_ref: string
  itemdescription: string
  magento_id_product: string
  name: {}
  page_url: string
  url_prefix: string
  _imageurl: string
  _thumburl: string
  price_au: number
  price_label: {}
}

export const UpsellProduct: React.FunctionComponent<any> = ({ productId }: { productId: string}) => {
  const [themeDetails, setThemeDetails] = useState({} as any);
  const isMobile = window.matchMedia("(max-width: 767px)").matches;
  const channel = isMobile ? "mobile" : "desktop";

  const fetchThemeData = async (productId: string) => {
    try {
      const response = await fetch(
        `/datasource/fetch/product?magento_id_product=${productId}&channel=${channel}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const themeData = await response.json();
      setThemeDetails(themeData?.themes);
    } catch (e) {
      console.error("Error fetching theme data");
    }
  };

  useEffect(() => {
    if (productId) {
      fetchThemeData(productId);
    }
  }, []);

  const formatPrice = (price: any) => {
    let finalPrice: string = "";

    if (price) {
      const formattedPrice = parseFloat(price as any);
      if (!isNaN(formattedPrice)) {
        finalPrice = formattedPrice.toFixed(2);
      }
    }

    return finalPrice;
  };

  const getUrl = (product: UpsellProduct) => {
    let base_url = (window as any).authenticationPopup?.baseUrl;
    let url_prefix = product?.url_prefix || "";
    let page_url = product?.page_url;

    return `${base_url}${url_prefix}${page_url}`
  }

  if (!themeDetails?.pdp_stylewith?.items?.length) return null;


  return (
      <>
        <div className="upsell-title"><h2>Customers Also Purchased</h2></div>
        <div className="upsell-product-collection">
          {themeDetails?.pdp_stylewith?.items.map((product: any) => {
            return (
                <div className="product">
                  <UpsellProductTile
                      url={getUrl(product)}
                      handleAction={() => {}}
                      image={product?._thumburl}
                      heading={Object.values(product?.heading)?.[0] as string}
                      priceLabel={Object.values(product?.price_label)?.[0] as string}
                      priceAfter={product?.special_price ? formatPrice(product?.special_price) : undefined}
                      priceBefore={product?.price ? formatPrice(product?.price) : formatPrice(product?.price_au)}
                      rewardsPrice={formatPrice(product?.rewards_price)}
                  />
                </div>
            );
          })}
        </div>
      </>
  );
};
